import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 7.75C6 6.7835 6.7835 6 7.75 6H16.25C17.2165 6 18 6.7835 18 7.75V16.25C18 17.2165 17.2165 18 16.25 18H7.75C6.7835 18 6 17.2165 6 16.25V7.75ZM7.75 7.5C7.61193 7.5 7.5 7.61193 7.5 7.75V16.25C7.5 16.3881 7.61193 16.5 7.75 16.5H16.25C16.3881 16.5 16.5 16.3881 16.5 16.25V7.75C16.5 7.61193 16.3881 7.5 16.25 7.5H7.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgSquare;
